module.exports = __webpack_public_path__ + "img/filterbgimg.b657acc1.png";